import { Box } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

export default function ReactCustomMap({locationList=[]}) {
const customIcon = new L.Icon({
  iconUrl:
    "https://cdn.jsdelivr.net/gh/pointhi/leaflet-color-markers@master/img/marker-icon-blue.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowUrl:'https://cdn.jsdelivr.net/gh/pointhi/leaflet-color-markers@master/img/marker-shadow.png',
shadowSize: [41, 41],
});
const [locations, setLocations] = useState([]);
useEffect(() => {
  if (locationList.length > 0) {
    const validLocations = locationList
      .filter(
        (location) =>
          location?.lat_lng.split(",").length === 2 &&
          location?.lat_lng.split(",")[0] !== "" &&
          location?.lat_lng.split(",")[1] !== ""
      )
      .map((location) => ({
        lat: location?.lat_lng?.split(",")[0],
        lng: location?.lat_lng.split(",")[1],
        name: location?.location,
      }));

    setLocations(validLocations);
  }
}, [locationList]);
    
  return (
    <Box
      w={{ base: "100%", md: "100%" }}
      h={"auto"}
      border='1px solid'
      borderColor='rgba(255, 255, 255, 0.15)'
      filter='blur(0px)'
      boxShadow='0px 7px 23px rgba(0, 0, 0, 0.05)'
      bg='linear-gradient(126.97deg, #060C29 28.26%, rgba(4, 12, 48, 0.5) 91.2%)'
      borderRadius='10px'
      display={{ sm: "none", md: "flex" }}
      datatype='map'
      justifyContent={"center"}
      alignItems={"center"}
    >
      <MapContainer
        center={[23.685, 90.3563]}
        zoom={1.5}
        style={{
          height: "100%",
          width: "100%",
          borderRadius: "10px",
          borderColor: "rgba(255, 255, 255, 0.15)",
          border: "1px solid",
          boxShadow: "0px 7px 23px rgba(0, 0, 0, 0.05)",
          filter: "blur(0px)",
        }}
      >
        <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />
        {locations.map((location, index) => (
          <Marker
            key={index}
            position={[location.lat, location.lng]}
            icon={customIcon} 
          >
            <Popup>{location.name}</Popup>
          </Marker>
        ))}
      </MapContainer>
    </Box>
  );
}
